import { HttpBackend } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class PendingOrdersCfg {
  public summaryEndpointPattern: string;
  public detailEndpointPattern: string;
  public teaDetailEndpointPattern: string;
  public permDetailEndpointPattern: string;
}

export class OrdersKpiCfg {
  public pendingOrders: PendingOrdersCfg;
}

@Injectable()
export class OrdersKpiCfgService extends CfgService<OrdersKpiCfg> {
  json: any = {
    pendingOrders: {
      summaryEndpointPattern: "%{DashboardApiUrl}/orders/{0}/pending?beginDate={1}&endDate={2}",
      detailEndpointPattern: "%{OrdersFrontUrl}/orderslines/0/{0}/{1}?branchId={2}",
      teaDetailEndpointPattern: "%{OrdersFrontUrl}/orderslines/0/{0}/{1}?branchId={2}",
      permDetailEndpointPattern: "%{OrdersFrontUrl}/orderslines/0/{0}/{1}?branchId={2}"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/ordersKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
